import api from '../api';

export interface SearchCount {
  total: number | null;
  total_capped?: boolean;
  count_id?: string;
  count_status?: 'pending' | 'ready' | 'error';
  count_error?: string;
  counted_at?: string;
}

export async function getSearchCount(id: string, signal: AbortSignal, retry = false): Promise<SearchCount> {
  const { data } = await api.get<SearchCount>(`/lots/counts/${encodeURIComponent(id)}`, {
    signal, timeout: 10000, params: retry ? { retry: true } : undefined,
  });
  return data;
}
